/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type QueueRoute_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ModerateCardContainer_viewer">;
    readonly " $refType": "QueueRoute_viewer";
};
export type QueueRoute_viewer$data = QueueRoute_viewer;
export type QueueRoute_viewer$key = {
    readonly " $data"?: QueueRoute_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"QueueRoute_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueueRoute_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerateCardContainer_viewer"
        }
    ],
    "type": "CoralUser",
    "abstractKey": null
} as any;
(node as any).hash = 'fae83c1d040e126944f38c9937d6428f';
export default node;
